import React from "react";

/** Shared navigation for compact administration settings. */
export function SettingsTabs({
  items,
  value,
  onChange,
  id,
  disabled = false,
  label = "Configurações",
}) {
  function navigate(event, index) {
    if (disabled) return;
    const keys = {
      ArrowRight: (index + 1) % items.length,
      ArrowLeft: (index + items.length - 1) % items.length,
      Home: 0,
      End: items.length - 1,
    };
    if (keys[event.key] === undefined) return;
    event.preventDefault();
    const next = keys[event.key];
    onChange(items[next].id);
    const target = document.getElementById(id + "-tab-" + items[next].id);
    if (target) target.focus();
  }
  return (
    <div
      className="nav nav-tabs xv-settings-tabs"
      role="tablist"
      aria-label={label}
    >
      {items.map((item, index) => (
        <button
          type="button"
          disabled={disabled}
          key={item.id}
          id={id + "-tab-" + item.id}
          className={"nav-link" + (value === item.id ? " active" : "")}
          role="tab"
          aria-selected={value === item.id}
          aria-controls={id + "-panel-" + item.id}
          tabIndex={value === item.id ? 0 : -1}
          onClick={() => onChange(item.id)}
          onKeyDown={(event) => navigate(event, index)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
export function SetupSteps({ steps, current, onChange }) {
  return (
    <ol className="xv-setup-steps" aria-label="Etapas da integração">
      {steps.map((label, index) => (
        <li key={label} aria-current={current === index ? "step" : undefined}>
          <button
            type="button"
            className="xv-setup-steps__button"
            onClick={() => onChange(index)}
            aria-label={"Etapa " + (index + 1) + ": " + label}
          >
            <span className="xv-setup-steps__number" aria-hidden="true">
              {index + 1}
            </span>
            <span>{label}</span>
          </button>
        </li>
      ))}
    </ol>
  );
}
